import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import SearchPanelFull from '../containers/SearchPanelFull';
import SearchPanelNarrow from '../containers/SearchPanelNarrow';

const SearchPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: SearchPanelFull, narrow: SearchPanelNarrow }}
    onChange={onChange}
    width={550}
  />
);

export default SearchPanel;
